# Acceptable Use Policy

**Partiri – partiri.cloud**

Your use of Partiri's platform and services ("Service") is subject to the [Partiri Terms of Service](/terms) and this Acceptable Use Policy ("AUP"). By using the Service, you agree to comply with this policy. Partiri reserves the right to suspend or terminate your account, with or without notice, at its sole discretion, if you are found to be in violation of this policy.

We may update this Acceptable Use Policy from time to time. It is your responsibility to review and adhere to the most current version posted at [partiri.cloud](https://partiri.cloud). All capitalized terms used herein have the meanings stated in the Terms of Service, unless stated otherwise.

---

## Permitted Uses

The Service is designed to host and run legitimate workloads, including but not limited to:

- Websites and web applications
- APIs and backend services
- Cron jobs and scheduled tasks
- Machine learning workloads
- Development and staging environments

---

## Prohibited Uses

We would love to give an exhaustive list of acceptable and unacceptable activities, but we cannot predict every possible use case. As a general rule: don't do anything on Partiri that negatively impacts our infrastructure, services, other customers, or third parties. If you wouldn't run it on your own infrastructure, don't run it on ours.

You agree **not** to use the Service to:

### Engage in Illegal or Harmful Activities

Post, transmit, host, or distribute unlawful, abusive, defamatory, hateful, or otherwise objectionable content. This includes any content that promotes or depicts child sexual exploitation or abuse, violent or harassing content such as doxxing or revenge pornography, or any activity that violates applicable law — including the laws of the Federal Republic of Germany and applicable European Union regulations.

### Abuse Platform Resources

Impose an unreasonable or disproportionately large load on our infrastructure, intentionally upload excessive amounts of data, or otherwise use the Service in a manner that degrades performance for other users. This includes cryptocurrency mining and any similar resource-intensive activity not related to a legitimate hosted application.

### Bypass Access, Usage, or Payment Restrictions

Attempt to bypass, circumvent, or defeat any access restrictions, usage limits, authentication mechanisms, or security measures. This includes any intentional misuse of the Service to evade payment or financial obligations, card testing, or hosting card-testing services.

### Violate Security or Integrity

Attempt to interfere with or compromise the integrity, security, or availability of the Service, including unauthorized network scanning, penetration testing, or phishing — unless you have obtained Partiri's express prior written consent.

### Send Unsolicited Communications

Transmit spam, chain messages, unsolicited bulk email, or any other form of unsolicited messaging or advertising through the Service, or proxy or serve spam content.

### Infringe Intellectual Property or Privacy Rights

Host, distribute, or facilitate access to content that infringes upon copyrights, trademarks, or other intellectual property rights (including through bots, torrents, or mirrors of protected content). Collect personal data from other users without proper consent, in violation of the EU General Data Protection Regulation (GDPR) or other applicable data protection laws.

### Transmit Malicious Content

Upload, transmit, or distribute viruses, malware, worms, Trojan horses, ransomware, corrupted files, or any other material intended to damage or interfere with the operation of the Service or any other system, network, or data.

### Impersonate or Misrepresent

Impersonate any person or entity, or misrepresent your affiliation, identity, or the purpose of your use of the Service.

### Resell or Misuse the Service

Resell, rent, lease, or otherwise provide the Service to third parties without Partiri's express written consent, or use the Service for any unauthorized commercial purpose.

---

## Enforcement

We reserve the right to investigate any suspected violation of this Acceptable Use Policy. In the event of a suspected or actual violation, we may, at our sole discretion:

- Issue a warning,
- Remove or disable access to any content or resource believed to be in violation,
- Suspend or terminate your account.

You agree to cooperate fully with us in any investigation or enforcement action related to your use of the Service, including providing information and taking any remedial actions we reasonably request. We are also obligated to comply with applicable German and EU law, including lawful requests from competent authorities.

---

## Reporting Violations

If you become aware of any violation of this Acceptable Use Policy, please report it promptly to **legal@partiri.cloud**. We will review all reports and take appropriate action to protect the integrity and security of the Service.

---

## Contact

If you have questions about this policy, feel free to reach out at **legal@partiri.cloud**.